import React from 'react';

export function Finland(props) {
  return (
    <svg width="513" height="342" viewBox="0 0 513 342" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="513" height="342" fill="white"/>
      <rect x="0" y="126" width="513" height="76" fill="#003580"/>
      <rect x="157" y="0" width="76" height="342" fill="#003580"/>
    </svg>
  );
}
